var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"markdown"},domProps:{"innerHTML":_vm._s(_vm.markdown)}})
}
var staticRenderFns = []

export { render, staticRenderFns }